import { fetchProducts, type CountryCode } from "@/lib/shopify";

/** Keep each market's search prices separate, including a gift recipient's market. */
export function searchProductsQueryOptions(country: CountryCode, open: boolean) {
  return {
    queryKey: ["products", "search", country] as const,
    queryFn: () => fetchProducts(50, country),
    enabled: open,
    staleTime: 5 * 60_000,
  };
}
